import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { type RootState } from "../../store";
import { API } from "../../../api/Api";
import {
  type GetSalesStatisticsParams,
  type SalesSchema,
} from "./statisticsTypes";
import moment from "moment";
// import { TelemetryAPI } from "../../../api/TelemetryApi";
import "moment/locale/ru"; // without this line it didn't work

moment.locale("ru");

export interface StatisticsState {
  salesStatistics: SalesSchema[];
  total: number;
  qty: number;
  loading: boolean;
}

const initialState: StatisticsState = {
  salesStatistics: [],
  total: 0,
  qty: 0,
  loading: false,
};

export const getSalesStatisticsAsync = createAsyncThunk(
  "statistics/getSalesStatistics",
  async (params: GetSalesStatisticsParams, { rejectWithValue }) => {
    console.log("getUsers");
    try {
      const response = await API.getSalesStatistics(params);
      // console.log('responseresponseresponse', response)
      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.data?.detail != null) {
        return rejectWithValue(error.response.data.detail);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const statisticsSlice = createSlice({
  name: "statistics",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getSalesStatisticsAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSalesStatisticsAsync.fulfilled, (state, action) => {
        state.loading = false;
        const start = moment(
          action.payload.salesStatistics[0]?.ts,
          "YYYY-MM-DDTHH:mm:ss",
        );
        const end = moment(
          action.payload.salesStatistics[
            action.payload.salesStatistics.length - 1
          ]?.ts,
          "YYYY-MM-DDTHH:mm:ss",
        );
        console.log("start end", start.format(), end.format());
        const range = end.diff(start, "days");
        console.log("range", range);
        state.salesStatistics = action.payload.salesStatistics.map(
          (item: SalesSchema) => {
            if (range > 0)
              item.ts = moment(item.ts, "YYYY-MM-DDTHH:mm:ss").format("D MMMM");
            else item.ts = moment(item.ts, "YYYY-MM-DDTHH:mm:ss").format("LT");
            return item;
          },
        );
        state.total = action.payload?.total;
        state.qty = action.payload?.qty;
      })
      .addCase(getSalesStatisticsAsync.rejected, (state, action) => {
        // message.error(action.payload)
        console.log("error", action.payload);
        state.loading = false;
      });
  },
});

export const selectSalesStatistics = (state: RootState): SalesSchema[] =>
  state.statistics.salesStatistics;

export const selectTotalStatistics = (state: RootState): number =>
  state.statistics.total;

export const selectQtyStatistics = (state: RootState): number =>
  state.statistics.qty;

export const selectStatisticsLoading = (state: RootState): boolean =>
  state.statistics.loading;

export default statisticsSlice.reducer;
